module.exports = __webpack_public_path__ + "img/chevron-right.87cd4782.svg";